<template>
  <div class="hold-transition sidebar-mini">
    <div class="wrapper">
      <nav class="main-header navbar navbar-expand navbar-white navbar-light">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" data-widget="pushmenu" href="#" role="button">
              <i class="fas fa-bars"></i>
            </a>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" data-widget="fullscreen" href="#" role="button">
              <i class="fas fa-expand-arrows-alt"></i>
            </a>
          </li>
          <li class="nav-item dropdown user-menu">
            <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
              <img src="" id="photo_profile1" class="user-image img-circle elevation-2" alt="User Image"
                onerror="this.onerror=null;this.src='/default/profile.png';">
            </a>
            <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <!-- User image -->
              <li class="user-header">
                <img src="" id="photo_profile2" class="img-circle elevation-2" alt="User Image"
                  onerror="this.onerror=null;this.src='/default/profile.png';">
                <p>
                  {{ user.name }}
                  <small>Terdaftar sejak {{ since }}</small>
                </p>
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <Link :href="`/profile/${user.id}/edit`" class="btn btn-default btn-flat" id="profile">Profile
                </Link>
                <Link href="/logout" class="btn btn-default btn-flat float-right" method="post" as="button"
                  type="button">
                Sign out
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <aside class="main-sidebar sidebar-dark-primary elevation-4">
        <Link href="/home" class="brand-link">
        <img src="/default/logo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
          style="opacity: 0.8;" />
        <span class="brand-text font-weight-light">KUNJUNGAN</span>
        </Link>

        <Sidebar />
      </aside>

      <div class="content-wrapper">
        <section class="content-header">
        </section>

        <section class="content">
          <div class="row">
            <div class="col-sm-12">
              <slot />
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import { Link, usePage } from '@inertiajs/vue3'
import Sidebar from '@/Layouts/Sidebar'
import Footer from '@/Layouts/Footer';
import { computed } from 'vue'

export default {
  components: {
    Sidebar,
    Footer,
    Link,
  },
  setup() {
    let user = computed(() => usePage().props.auth.user)
    let month = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    let d = new Date(usePage().props.auth.user.created_at)
    let since = month[d.getMonth()] + " " + d.getFullYear()

    return { user, since }
  },
  mounted() {
    if (this.user.picture !== null) {
      let photo = '/img/images/users/' + usePage().props.tenant + '/' + this.user.picture

      $("#photo_profile1").attr("src", photo + '?w=40&h=40&fit=crop')
      $("#photo_profile2").attr("src", photo + '?w=200&h=200&fit=crop')
    }
  },
}
</script>

<style scoped>
/* Gaya untuk konten footer biasa */
@media screen and (max-width: 600px) {
  .content {
    padding-bottom: 4rem;
  }
}
</style>